import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Button,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { Menu as ExpandLess, ExpandMore } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import SegmentRoundedIcon from "@mui/icons-material/SegmentRounded";
import logo from "../../assets/Images/logo.png";
import "../Header/Header.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useDispatch, useSelector } from "react-redux";
// import { userLogout } from "../../Actions/AuthAction";
import { useLocation } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Link } from "react-router-dom";

const menuData1 = [
  {
    title: "Home",
    url: "/",
    items: [],
  },
  {
    title: "Product",
    icon: <KeyboardArrowDownIcon />,
    icon2: <KeyboardArrowUpIcon />,
    items: [
      {
        links: "/currencies",
        title: "Currency",
      },
      {
        links: "/crypto-currencies",
        title: "Cryptocurrencies",
      },
      {
        links: "/commodities",
        title: "Commodities",
      },
      {
        links: "/indicies",
        title: "Indices",
      },
    ],
  },
  // {
  //   title: "Trading Tools ",
  //   icon: <KeyboardArrowDownIcon />,
  //   icon2: <KeyboardArrowUpIcon />,
  //   items: [
  //     {
  //       links: "/economic-calender",
  //       title: "Economic Calendar",
  //     },
  //   ],
  // },

  {
    title: "Trading Tools ",
    url: "/trading-tools",
    items: [],
  },
  {
    title: "Platforms",
    icon: <KeyboardArrowDownIcon />,
    icon2: <KeyboardArrowUpIcon />,
    items: [
      {
        links: "/mt5-trader",
        title: "MT5 ",
      },
      {
        links: "/copy-trading",
        title: "Copy Trading",
      },
      {
        links: "/pamm",
        title: "PAMM",
      },
    ],
  },
  {
    title: "FAQs",
    url: "/faq",
    items: [],
  },
  {
    title: "Contact Us",
    url: "/contactus",
    items: [],
  },
];

const menuData = [
  {
    title: "Product",
    items: [
      {
        // heading: "Products",
        links: [
          { name: "Currency", url: "/currencies" },
          { name: "Cryptocurrencies ", url: "/crypto-currencies" },
          { name: "Commodities ", url: "/commodities" },
          { name: "Indices ", url: "/indicies" },
        ],
      },
    ],
  },
  // {
  //   title: "Trading Tools",
  //   items: [
  //     {
  //       heading: "Tools ",
  //       links: [
  //         { name: "Economic Calendar", url: "/economic-calender" },
  //         // { name: "Trading Conditions", url: "/" },
  //       ],
  //     },
  //   ],
  // },

  {
    title: "Trading Tools",
    url: "/trading-tools",
  },
  {
    title: "Platform",
    items: [
      {
        // heading: "Platform",
        links: [
          { name: "MT5", url: "/mt5-trader" },
          { name: "Copy Trading", url: "/copy-trading" },
          { name: "PAMM ", url: "/pamm" },
        ],
      },
    ],
  },
  {
    title: "FAQs",
    url: "/faq",
  },
  {
    title: "Contact Us",
    url: "/contactus",
  },
  // {
  //   title: "Academy",
  //   items: [
  //     {
  //       heading: "Education",
  //       links: [
  //         { name: "Webinars", url: "/" },
  //         { name: "Video Tutorials", url: "/" },
  //       ],
  //     },
  //   ],
  // },
  //   {
  //     title: "Contact us",
  //  url:"/contactrequest",
  //  items: [
  //   {
  //     heading: "Get in Touch",
  //     links: [{ name: "Contact Us", url: "/contactrequest" }],
  //   },
  // ],
  //   },
];

const MegaMenu = () => {
  const navigate = useNavigate();
  // const [anchorEl, setAnchorEl] = useState(null);
  // const [activeMenu, setActiveMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  const handleMenuClick = (event, title) => {
    if (activeMenu === title) {
      setAnchorEl(null);
      setActiveMenu(null);
    } else {
      setAnchorEl(event.currentTarget);
      setActiveMenu(title);
    }
  };
  const handleMenuhover = (event, title) => {
    // If the same menu is active, do nothing (optional logic to avoid flicker)
    // if (activeMenu === title) return;

    setAnchorEl(event.currentTarget); // sets the anchor (optional if you're positioning a dropdown)
    setActiveMenu(title); // tracks which menu is active
  };
  // const handleMenuClose = () => {
  //   setAnchorEl(null);
  //   setActiveMenu(null);
  // };

  const handleMobileToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleExpand = (title) => {
    setExpandedMenu(expandedMenu === title ? null : title);
  };

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  let timeoutId = null; // Prevents flickering when moving between elements

  const handleMenuHover = (event, title) => {
    clearTimeout(timeoutId); // Prevent accidental closing
    setAnchorEl(event.currentTarget);
    setActiveMenu(title);
  };

  const handleMenuClose = () => {
    timeoutId = setTimeout(() => {
      setAnchorEl(null);
      setActiveMenu(null);
    }, 300); // Slight delay to prevent flicker
  };
  const { pathname } = useLocation();
  const currentPath = pathname.split("/").filter(Boolean).pop();
  // const { isAuthenticated } = useSelector((state) => state.auth);

  // menu new
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const [anchorEl3, setAnchorEl3] = React.useState(null);
  const open3 = Boolean(anchorEl3);
  const handleClickAddAlert = (event) => {
    setAnchorEl3(event.currentTarget);
  };
  const handleClose3 = () => {
    setAnchorEl3(null);
  };

  const handleMenuClick1 = (event, title) => {
    if (activeMenu === title) {
      setAnchorEl(null);
      setActiveMenu(null);
    } else {
      setAnchorEl(event.currentTarget);
      setActiveMenu(title);
    }
  };

  const handleMenuClose1 = () => {
    setAnchorEl(null);
    setActiveMenu(null);
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#000 !important",
        padding: "5px 20px",
        zIndex: "999",
      }}
      className="sticky-header"
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          maxWidth: { sm: "900px", lg: "1150px", xl: "1500px" },
          margin: { sx: "0", md: "0 auto" },
          width: { sx: "auto", md: "100%" },
          padding: "0",
        }}
      >
        <Link to="/" sx={{ cursor: "pointer" }}>
          <div className="logo">
            <img src={logo} alt="" />
          </div>
        </Link>

        {/* Desktop Menu */}
        {/* <div
          className="menu-title"
          style={{ display: md ? "block" : "none", gap: "20px" }}
        >
          {menuData.map((menu) => (
            <Button
              key={menu.title}
              onMouseEnter={(e) => handleMenuHover(e, menu.title)} // Show submenu on hover
              className={`menu-wrapper ${
                activeMenu === menu.title ? "active-menu-item" : ""
              }`}
              sx={{
                color: activeMenu === menu.title ? "#EDC967" : "white",
                cursor: "pointer",
                "&:hover": { color: "#EDC967" },
              }}
            >
              {menu.title}
            </Button>
          ))}
        </div> */}

        {/* Desktop Menu */}
        {/* <div
          className="menu-container"
          style={{ display: lg ? "flex" : "none", gap: "20px" }}
        >
          {menuData.map((menu) => (
            <div key={menu.title} className="menu-wrapper">
              <Button
                onClick={menu.url ? () => navigate(menu.url) : null}
                className="menu-title"
                sx={{
                  color: "white",
                  cursor: "pointer",
                  padding: "20px 16px !important",
                }}
              >
                {menu.title}
                {!menu.url && <ExpandMore className="arrow" />}
              </Button>

              {!menu.url && (
                <div
                  className="menu-dropdown-home "
                  style={{
                    mt: 1,
                    "& .MuiPaper-root": {
                      top: "55px !important",
                      left: "0 !important",
                      maxWidth: "none !important",
                      width: "100%",
                      background: "#000 !important",
                    },
                  }}
                >
                  <Grid
                    container
                    className="mega-menu-content"
                    sx={{
                      maxWidth: { sm: "900px", lg: "1100px", xl: "1300px" },
                      gap: { lg: "120px", md: "150px" },
                      margin: "0 auto",
                      paddingTop: "80px",
                      paddingBottom: "30px",
                    }}
                  >
                    {menu.items.map((section, idx) => (
                      <Grid item xs={4} key={idx}>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {section.heading}
                        </Typography>
                        {section.links.map((link, linkIdx) => (
                          <MenuItem
                            key={linkIdx}
                            onClick={() => navigate(link.url)}
                          >
                            {link.name}
                          </MenuItem>
                        ))}
                      </Grid>
                    ))}
                  </Grid>
                </div>
              )}
            </div>
          ))}
        </div> */}
        {/* Desktop Menu */}
        <div className="menu-title" style={{ display: lg ? "block" : "none" }}>
          {menuData1.map((menu) => (
            <Button
              key={menu.title}
              onMouseOver={(e) => handleMenuhover(e, menu.title)}
              onClick={(e) => {
                if (menu.url) {
                  // Navigate to Market URL if it exists
                  // window.location.href = menu.url;
                  navigate(menu.url);
                } else {
                  handleMenuClick1(e, menu.title);
                }
              }}
              className="menu-title"
              sx={{
                // color: pathname.startsWith(menu.url) ? "#ff9247 " : "#fff", // <-- HIGHLIGHT
                color: "#fff",
                cursor: "pointer",
                "&:hover": { color: "#3665ff" },
              }}
              endIcon={activeMenu === menu.title ? menu.icon2 : menu.icon}
            >
              {menu.title}
            </Button>
          ))}
        </div>
        {/* Mega Menu Dropdown for Desktop */}
        {menuData1.find((menu) => menu.title === activeMenu)?.items?.length >
          0 && (
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose1}
              className="menu-dropdown header-menu-after"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              sx={{
                mt: 1,
                "& .MuiPaper-root": {
                  maxWidth: "none !important",
                  // width: "300px",
                },
              }}
              MenuListProps={{
                onMouseLeave: handleMenuClose,
              }}
            >
              <Grid
                container
                sx={{
                  // maxWidth: "300px",
                  margin: "0 auto",
                  // justifyContent: "center",
                  display: "block",
                }}
              >
                {menuData1
                  .find((menu) => menu.title === activeMenu)
                  ?.items.map((section, idx) => (
                    <Grid item xs={4} key={idx} sx={{ px: 2 }}>
                      {/* <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    {section.heading}
                  </Typography> */}
                      {/* {section.map((linkItem, linkIdx) => ( */}
                      <MenuItem
                        onClick={handleMenuClose1}
                        sx={{ display: "block" }}
                      >
                        <Link
                          to={section.links}
                          style={{
                            color: "#fff",
                            fontSize: "17px",
                            fontWeight: "400",
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          {/* {section.icon} */}
                          {section.title}
                        </Link>
                      </MenuItem>
                      {/* ))}  */}
                    </Grid>
                  ))}
              </Grid>
            </Menu>
          )}

        {/* Buttons */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            gap: "15px",
          }}
          className="header-btn"
        >
          <Button
            onClick={() => {
              window.location.href = "https://auth-finowiz-frontend-2024.pages.dev/login";
            }}
            sx={{ textTransform: "none" }}
          >
            Login
          </Button>
          <Button
            onClick={() => {
              window.location.href = "https://auth-finowiz-frontend-2024.pages.dev/register";
            }}
            className="gradient-border-button"
          >
            <span class="button-inner">Register</span>
          </Button>

          {/* {!isAuthenticated && (
              <Button
                onClick={() => {
                  navigate("/login");
                  dispatch(userLogout());
                }}
                sx={{ textTransform: "none" }}
              >
                LogOut
              </Button>
            ) : (
            <></>
          )} */}
          {/* {isAuthenticated && (
            <Button
              onClick={() => {
                navigate("/my-account");
              }}
              variant="outlined"
              sx={{
                borderColor: "#FFD700",
                color: "#FFD700",
                textTransform: "none",
                borderRadius: "8px",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            >
              My Accounts
            </Button>
          )} */}
        </Box>

        {/* Mobile Menu Button */}
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleMobileToggle}
          sx={{ display: { lg: "none" } }}
        >
          <SegmentRoundedIcon />
        </IconButton>
      </Toolbar>

      {/* Mega Menu Dropdown for Desktop */}
      {/* <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        onMouseEnter={() => clearTimeout(timeoutId)} // Prevent closing when hovering over menu
        onMouseLeave={handleMenuClose} // Close when fully leaving
        className={activeMenu ? "active-menu-dropdown" : ""}
        // className="menu-dropdown"
        sx={{
          mt: 1,
          "& .MuiPaper-root": {
            top: "55px !important",
            left: "0 !important",
            maxWidth: "none !important",
            width: "100%",
            background: "#000 !important",
          },
        }}
      >
        <Grid
          container
          sx={{
            maxWidth: "1300px",
            margin: "0 auto",
            paddingTop: "80px",
            paddingBottom: "30px",
            gap: "200px",
          }}
        >
          {menuData
            .find((menu) => menu.title === activeMenu)
            ?.items.map((section, idx) => (
              <Grid item xs={4} key={idx} sx={{ px: 0 }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  {section.heading}
                </Typography>
                {section.links.map((link, linkIdx) => (
                  <MenuItem
                    key={linkIdx}
                    onClick={() => navigate(link.url)}
                    sx={{ px: 0 }}
                  >
                    <Link
                      to={link.url}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {link.name}
                    </Link>
                  </MenuItem>
                ))}
              </Grid>
            ))}
        </Grid>
      </Menu> */}

      {/* Mobile Drawer Menu */}
      <Drawer
        anchor="left"
        open={mobileOpen}
        // onClose={handleMobileToggle}
        className="mobile-menu-drop"
        sx={{
          mt: 1,
          "& .MuiPaper-root": {
            background: "#1D1D1D",
            color: "#fff",
          },
        }}
      >
        <div className="display-2 p-10">
          <Link
            onClick={() => {
              navigate("/");
            }}
            sx={{ cursor: "pointer" }}
          >
            <div className="logo">
              <img src={logo} alt="" />
            </div>
          </Link>
          <div onClick={handleMobileToggle}>
            <CloseRoundedIcon />
          </div>
        </div>

        <List sx={{ width: 320 }}>
          {menuData.map((menu) => (
            <div key={menu.title}>
              {menu.items ? (
                <>
                  <ListItem button onClick={() => toggleExpand(menu.title)}>
                    <ListItemText primary={menu.title} />
                    {expandedMenu === menu.title ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </ListItem>

                  <Collapse
                    in={expandedMenu === menu.title}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {menu.items.map((section, idx) => (
                        <div key={idx} className="mobile-menu-dropdown">
                          {section.heading && (
                            <Typography
                              component="div"
                              variant="subtitle2"
                              sx={{ pl: 4, mt: 1, fontWeight: "bold" }}
                            >
                              {section.heading}
                            </Typography>
                          )}
                          {section.links.map((link, linkIdx) => (
                            <ListItem
                              button
                              key={linkIdx}
                              sx={{ pl: 6 }}
                              onClick={() => navigate(link.url)}
                            >
                              <Link
                                style={{ textDecoration: "none", color: "inherit" }}
                              >
                                <ListItemText primary={link.name} />
                              </Link>
                            </ListItem>
                          ))}
                        </div>
                      ))}
                    </List>
                  </Collapse>
                </>
              ) : (
                <ListItem button onClick={() => navigate(menu.url)}>
                  <ListItemText primary={menu.title} />
                </ListItem>
              )}
            </div>
          ))}
        </List>
      </Drawer>
    </AppBar>
  );
};

export default MegaMenu;
